import type { ComponentProps, PropsWithChildren } from 'react';
import React from 'react';
import styled from '@emotion/styled';
import { alignItems, color, display, size } from 'styled-system';

import Icon from 'common/components/Icon';
import { LinkWithIcon } from 'common/components/Link';
import { BodyRegularBR1 } from 'common/components/Typography';
import { fill, whiteSpace } from 'common/theme/system-utilities';

interface SeeAllLinkProps extends PropsWithChildren {
  href: string;
  onClick: () => void;
  className?: string;
}

const StyledLink = styled(LinkWithIcon)<any>`
  ${color};
  ${display};
  ${alignItems};
  ${whiteSpace};
`;

const linkStyles: ComponentProps<typeof StyledLink> = {
  color: 'sys.neutral.border.hover',
  display: 'flex',
  alignItems: 'center',
  whiteSpace: 'nowrap',
};

const RIGHT_CHEVRON_SIZE = 16;
const RightChevron = styled(Icon)<any>`
  ${size};
  ${fill};
`;

const rightChevronStyles: ComponentProps<typeof RightChevron> = {
  size: RIGHT_CHEVRON_SIZE,
  fill: 'sys.neutral.border.default',
  role: 'presentation',
  name: 'arrowRight',
};

export const SeeAllLink = ({ href, onClick, className, children }: SeeAllLinkProps) => (
  <StyledLink {...linkStyles} href={href} onClick={onClick} className={className}>
    <BodyRegularBR1 as="span" color="inherit">
      {children}
    </BodyRegularBR1>
    <RightChevron {...rightChevronStyles} />
  </StyledLink>
);
